var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictureCard",on:{"click":function($event){return _vm.execute_func(_vm.item)}}},[_c('img',{staticClass:"pimg",attrs:{"src":_vm.item.img}}),_c('div',{staticClass:"ptitle"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('input',{ref:"fileUpload",staticClass:"filetpy",attrs:{"type":"file"},on:{"change":_vm.handleFileUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }